import axios from 'axios';
import { ConsultarTemaApiResponse, ConsultarTemaService } from './consultar-tema.types';

export const consultarTemaService: ConsultarTemaService = async ({ urlBase, token, query, idTurma, idTema }) => {
  const authorization = `Bearer ${token}`;
  const url = `${urlBase}/turmas/${idTurma}/temas/${idTema}`;

  const params = Object.fromEntries(Object.entries(query).filter(([, value]) => value !== undefined));

  const { data } = await axios.get<ConsultarTemaApiResponse>(url, {
    headers: { authorization },
    params,
  });

  return data;
};
